<template>
    <div class="global-loading-overlay" v-if="showLoading">
        <div class="global-loading-overlay__loading sticky-top">
            <img class="loading__icon" src="./assets/icon-loading-spinner--dark.svg"><span class="loading__label"><slot name="default" /></span>
        </div>
    </div>
</template>

<script>
export default {
    name: "global-loading-overlay",
    props: {
        showLoading: false
    }
}
</script>
